import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "PY_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#PY_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "PY_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#PY_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.825 12a3.825 3.825 0 11-7.65 0 3.825 3.825 0 017.65 0z",
      stroke: "#272727",
      strokeWidth: 0.35
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 12a3 3 0 106 0 3 3 0 00-6 0zm5.65 0a2.65 2.65 0 11-5.3 0 2.65 2.65 0 015.3 0z",
      fill: "#272727"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v8h32V0H0z",
      fill: "#F05234"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 16v8h32v-8H0z",
      fill: "#3D58DB"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.616 10.002l.284.411c-.66.457-.958.993-.714 1.903.241.902.808 1.349 1.75 1.382l-.017.5c-1.162-.04-1.947-.517-2.245-1.632-.296-1.105.1-1.981.942-2.564z",
      fill: "#73BE4A"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 12.315l-.882.599.297-1.024-.842-.653 1.066-.034L16 10.2l.361 1.003 1.066.034-.842.653.297 1.024-.882-.599z",
      fill: "#FBCD17"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.168 10.176s1.127.78.722 2.291c-.406 1.512-1.985 1.567-1.985 1.567",
      stroke: "#73BE4A",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M14.565 9.044l.466.718-.466-.718z", fill: "#F7FCFF" })))
), a = t;
export {
  a as default
};
